import routes from '@config/routes.json';
import { BurgerMenuItemTypes, IBurgerMenuItem } from './burgerMenu.d';

export const authItems = {
    advertiser: [
        {
            key: 'MyProfile',
            type: BurgerMenuItemTypes.link,
            id: 'MenuMobileMyProfileDropdown',
            href: routes.profile,
        },
        {
            key: 'Campaigns',
            type: BurgerMenuItemTypes.link,
            id: 'MenuMobileCampaignsDropdown',
            href: routes.campaigns,
        },
        {
            key: 'Bloggers',
            type: BurgerMenuItemTypes.link,
            id: 'MenuMobileBloggersDropdown',
            href: routes.bloggers,
        },
        {
            key: 'Integrations',
            type: BurgerMenuItemTypes.link,
            id: 'MenuMobileStatisticDropdown',
            href: routes.integrations.list,
        },
        {
            key: 'My Traffic Sources',
            type: BurgerMenuItemTypes.link,
            id: 'MenuMobileTrafficSourcesLink',
            href: routes.placements.list,
        },
        {
            key: 'Finance',
            type: BurgerMenuItemTypes.link,
            id: 'MenuMobileFinanceLink',
            href: routes.dashboard,
        },
    ] as IBurgerMenuItem[],
    blogger: [
        {
            key: 'MyProfile',
            type: BurgerMenuItemTypes.link,
            id: 'MenuMobileMyProfileDropdown',
            href: routes.profile,
        },
        {
            key: 'Integrations',
            type: BurgerMenuItemTypes.link,
            id: 'MenuMobileStatisticDropdown',
            href: routes.integrations.list,
        },
        {
            key: 'My Traffic Sources',
            type: BurgerMenuItemTypes.link,
            id: 'MenuMobileTrafficSourcesLink',
            href: routes.placements.list,
        },
        {
            key: 'Finance',
            type: BurgerMenuItemTypes.link,
            id: 'MenuMobileFinanceLink',
            href: routes.dashboard,
        },
    ] as IBurgerMenuItem[],
};

export const notAuthItems = [] as IBurgerMenuItem[];
